export default [
    {
        path: '/dynamic-divisions',
        name: 'dynamic-divisions',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Divisão',
            icon: 'mdi-division-box',
            breadcrumbs: [
                { text: 'Divisão dinâmica', disabled: true, href: '/' },
                { text: 'Divisão', disabled: true, href: '/' },
            ],
        }
    },
]